import React, { useContext } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import Tooltip from "@material-ui/core/Tooltip";
import { colors } from "../../../theme";
import lines from "../../../assets/lines.svg";
import {
  DrawerContext,
  BreakpointContext,
  LayoutContext,
} from "../../common/wrappers";
import { Text } from "../../common";
import { BellIcon } from "../../common/Svg";
import Boop from "../../common/Boop";
import HeaderDropdown from "./HeaderDropdown";
import withQuery from "../../onboardingV2/wrappers/gql/withQuery";
import { GET_APPLICATION_INFO } from "../../../api/gql";

const HeaderDesktop = ({ data: applicationInfo }) => {
  const { openDrawer } = useContext(DrawerContext);
  const { isBelow } = useContext(BreakpointContext);
  const { toggleForceCollapse } = useContext(LayoutContext);
  const { firstName } = applicationInfo.getApplicationInfo;
  return (
    <div className="flex-col">
      <div
        className="flex bg-off-white py-4 px-4 h-full items-center justify-between navbar-transition"
        style={{ borderBottom: "1px solid #EFF4F3" }}
      >
        <Tooltip title={isBelow("xl") ? "Please follow the instructions on the page to continue." : ''}>
          <button
            type="button"

            onClick={(e) =>
              !isBelow("xl") && toggleForceCollapse()
            }
            className="outline-0-important"
          >
            <img
              src={lines}
              alt="lines"
              style={{ height: "24px", width: "24px" }}
            />
          </button>
        </Tooltip>
        <nav
          id="navigation"
          className="flex items-center xl:w-full xl:justify-end"
        >
          {firstName && (
            <Text className="font-bold px-4">{`Hi, ${firstName}!`}</Text>
          )}
          <ul className="links">
            <li>
              <Tooltip
                title="Please follow the instructions on the page to continue."
              >
                <button
                  type="button"
                  className="ml-12 mx-5 outline-0-important"
                >
                  <Boop rotation={20} timing={200}>
                    <BellIcon color={colors["black-primary"]} />
                  </Boop>
                </button>
              </Tooltip>
            </li>
            <HeaderDropdown className="mr-3" />
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default withQuery(GET_APPLICATION_INFO)(HeaderDesktop);
